import { render, staticRenderFns } from "./SectionItem.vue?vue&type=template&id=c84ff992&scoped=true"
import script from "./SectionItem.vue?vue&type=script&lang=js"
export * from "./SectionItem.vue?vue&type=script&lang=js"
import style0 from "./SectionItem.vue?vue&type=style&index=0&id=c84ff992&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84ff992",
  null
  
)

export default component.exports